/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import AliasTypeEnum from './AliasTypeEnum';
import UInt64DTO from './UInt64DTO';





/**
* The AliasDTO model module.
* @module model/AliasDTO
* @version 0.7.15
*/
export default class AliasDTO {
    /**
    * Constructs a new <code>AliasDTO</code>.
    * @alias module:model/AliasDTO
    * @class
    * @param type {module:model/AliasTypeEnum} 
    */

    constructor(type) {
        

        
        



        this['type'] = type;

        
    }

    /**
    * Constructs a <code>AliasDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/AliasDTO} obj Optional instance to populate.
    * @return {module:model/AliasDTO} The populated <code>AliasDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AliasDTO();

            
            
            

            if (data.hasOwnProperty('type')) {
                obj['type'] = AliasTypeEnum.constructFromObject(data['type']);
            }
            if (data.hasOwnProperty('mosaicId')) {
                obj['mosaicId'] = UInt64DTO.constructFromObject(data['mosaicId']);
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/AliasTypeEnum} type
    */
    type = undefined;
    /**
    * @member {module:model/UInt64DTO} mosaicId
    */
    mosaicId = undefined;
    /**
    * The aliased address in hexadecimal.
    * @member {String} address
    */
    address = undefined;








}


